import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const data = createReducer(
  {},
  {
    [ActionTypes.FETCH_VOUCHER_SUCCESS]: (state, { payload }) => payload
  }
);

export default combineReducers({
  data
});
